import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LINK_DIRECTION_LABELS, type ShareLink } from "@shared/modules/x-avocats";
import { PageHeader } from "../../../core/components/ui/page-header";
import { Badge } from "../../../core/components/ui/badge";
import { formatDateTime } from "../../../core/lib/format";
import { listLinks } from "../lib/api";

export function AllLinksPage() {
  const [links, setLinks] = useState<ShareLink[]>([]);
  useEffect(() => {
    listLinks().then(setLinks).catch(() => setLinks([]));
  }, []);
  return (
    <div className="page">
      <PageHeader title="Liens sécurisés" subtitle="Tous les échanges avec les avocats, les plus récents d'abord." />
      <table className="table">
        <thead>
          <tr>
            <th>Dossier</th>
            <th>Sens</th>
            <th>Destinataire</th>
            <th>État</th>
            <th className="table__col--wide">Créé</th>
          </tr>
        </thead>
        <tbody>
          {links.map((l) => {
            const state = l.revokedAt ? "Révoqué" : l.consumedAt ? "Consommé" : new Date(l.expiresAt).getTime() < Date.now() ? "Expiré" : "Actif";
            return (
              <tr key={l.id}>
                <td>
                  <Link to={`/candidats/${l.candidateId}/partages`}>{l.candidateReference ?? "dossier"}</Link>
                </td>
                <td>{LINK_DIRECTION_LABELS[l.direction]}</td>
                <td>{l.email}</td>
                <td>
                  <Badge variant={state === "Actif" ? "success" : state === "Révoqué" ? "danger" : "neutral"}>{state}</Badge>
                </td>
                <td className="table__col--wide">{formatDateTime(l.createdAt, { dateStyle: "short", timeStyle: "short" })}</td>
              </tr>
            );
          })}
          {links.length === 0 ? (
            <tr>
              <td colSpan={5} className="table__empty">
                Aucun lien.
              </td>
            </tr>
          ) : null}
        </tbody>
      </table>
    </div>
  );
}
